(function(){
  'use strict';
  var root=document.documentElement;
  root.classList.add('hoi-js');
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealInit(scope){
    scope=scope||document;
    var selectors=[
      'main#MainContent > .shopify-section:not(:first-child)',
      'main#MainContent > section:not(:first-child)',
      '.product-card','.cat-card','.split-banner',
      '.features-grid .feature-item','.newsletter-band > *',
      'footer .footer-grid > *'
    ];
    var nodes=Array.prototype.slice.call(scope.querySelectorAll(selectors.join(',')));
    nodes.forEach(function(el){
      if(el.classList.contains('hoi-reveal')) return;
      el.classList.add('hoi-reveal');
      var group=el.closest('.product-grid,.cat-grid,.features-grid,.footer-grid');
      if(group){
        var siblings=Array.prototype.slice.call(group.children);
        var i=Math.max(0,siblings.indexOf(el));
        el.style.setProperty('--hoi-reveal-delay',Math.min(i,5)*80+'ms');
      }
    });
    if(reduce||!('IntersectionObserver' in window)){nodes.forEach(function(el){el.classList.add('hoi-in-view')});return;}
    var io=new IntersectionObserver(function(entries,observer){
      entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('hoi-in-view');observer.unobserve(entry.target)}});
    },{threshold:.08,rootMargin:'0px 0px -2% 0px'});
    nodes.forEach(function(el){io.observe(el)});
  }

  function cartIcon(){return document.querySelector('[data-open-cart], .header-icons a[href*="/cart"], .header-icons button[aria-label*="cart" i]')}
  function animateAdd(btn){
    var card=btn.closest('[data-product-card]');
    if(!card) return;
    card.classList.add('hoi-added');
    var original=btn.textContent;
    btn.textContent='Added ✓';
    setTimeout(function(){btn.textContent=original;card.classList.remove('hoi-added')},900);
    if(reduce) return;
    var img=card.querySelector('.product-media img');
    var target=cartIcon();
    if(img&&target){
      var a=img.getBoundingClientRect(),b=target.getBoundingClientRect();
      var clone=img.cloneNode(false);
      clone.className='hoi-cart-fly';
      clone.style.left=a.left+'px';clone.style.top=a.top+'px';clone.style.width='64px';clone.style.height='64px';
      document.body.appendChild(clone);
      requestAnimationFrame(function(){clone.style.transform='translate3d('+(b.left-a.left)+'px,'+(b.top-a.top)+'px,0) scale(.25)';clone.style.opacity='0'});
      target.classList.add('hoi-cart-pulse');
      setTimeout(function(){clone.remove();target.classList.remove('hoi-cart-pulse')},620);
    }
  }

  document.addEventListener('click',function(e){var btn=e.target.closest('[data-add-to-cart]');if(btn&&!btn.disabled) animateAdd(btn)},true);
  document.addEventListener('shopify:section:load',function(e){revealInit(e.target)});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){revealInit(document)});else revealInit(document);
})();
